$(document).ready(function() {


    // var notHasClass =  !$('.variations div').hasClass('size_guide_section');
    // if (notHasClass) {
    //   console.log("notssssssssss");
    //   $(".tab-section-pointure").remove();
    // } 
  
    var replacementMapPointureGabor = {
    "34.5": "1.5",
    "35": "2.5",
    "35.5": "3",
    "36": "3.5",
    "37": "4",
    "37.5": "4.5",
    "38": "5",
    "38.5": "5.5",
    "39": "6",
    "40": "6.5",
    "40.5": "7",
    "41": "7.5",
    "42": "8",
    "42.5": "8.5",
    "43": "9",
    "44": "9.5",
    "44.5": "10",
    "45": "10.5",
    "46": "11"
  };

  var replacementMapPointureDefault = {
    "1.5": "34.5",
    "2.5": "35",
    "3": "35.5",
    "3.5": "36",
    "4": "37",
    "4.5": "37.5",
    "5": "38",
    "5.5": "38.5",
    "6": "39",
    "6.5": "40",
    "7": "40.5",
    "7.5": "41",
    "8": "42",
    "8.5": "42.5",
    "9": "43",
    "9.5": "44",
    "10": "44.5",
    "10.5": "45",
    "11": "46"
  };

  // Select all span elements inside .variant-gabor + div.variations

  $(document).on('click', '.pointure-gabor', function(e) {
     $(".pointure-default").removeClass("active");
    $(".pointure-gabor").addClass("active");
    $("variant-selects span").each(function() {
      var text = $(this).text().trim(); // Get the text content of the span
      if (replacementMapPointureGabor.hasOwnProperty(text)) {
        $(this).text(replacementMapPointureGabor[text]); // Replace the text content if it matches a key in the map
      }
    });
  });

  $(document).on('click', '.pointure-default', function(e) {
     $(".pointure-gabor").removeClass("active");
      $(".pointure-default").addClass("active");
    $("variant-selects span").each(function() {
      var text = $(this).text().trim(); // Get the text content of the span
      if (replacementMapPointureDefault.hasOwnProperty(text)) {
        $(this).text(replacementMapPointureDefault[text]); // Replace the text content if it matches a key in the map
      }
    });
  });

  
});